import React from "react";
import { useSelector } from "react-redux";

import { selectNextStory } from "~redux/features/stories-slice";
import { decodeHtmlEntities } from "~utils/stringUtil";

import styles from "./UpNext.module.css";

interface UpNextProps {
    contentId?: string;
}

const UpNext: React.FunctionComponent<UpNextProps> = () => {
    const nextStory = useSelector(selectNextStory);

    if (!nextStory) {
        return null;
    }

    function handleKeyDown(e: any) {
        if (e.key === "Enter") {
            handleClick();
        }
    }

    function handleClick() {
        if (!nextStory) return;

        const art = document.querySelector(
            `article[data-story-id="${nextStory.id}"]`
        );
        window.scrollTo({
            top: art!.getBoundingClientRect().top + window.scrollY - 200,
            behavior: "smooth",
        });
    }

    const decodedHeadline = decodeHtmlEntities(nextStory.headline);

    return (
        <div
            tabIndex={0}
            role="button"
            aria-label={`Up Next: ${decodedHeadline}`}
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            className={styles.upNext}
            data-component="up-next"
        >
            <div className={styles.label}>Up Next</div>
            <div className={styles.headline} data-testid="headline">
                {decodedHeadline}
            </div>
        </div>
    );
};
export default UpNext;
